<ng-container [formGroup]="$any(controller.filterForm)">
	<div class="md:flex md:flex-none md:w-44 grid grid-cols-3 gap-6">
		<div class="md:hidden self-center whitespace-pre-line">
			{{ controller.i18n + '.date.text' | translate }}
		</div>
		<div class="col-span-2">
			<div class="flex items-center space-x-1">
				<div class="p-inputgroup">
					<p-calendar
						[showClear]="true"
						class="w-full"
						appendTo="body"
						formControlName="date"
						selectionMode="range"
						styleClass="w-full"
					></p-calendar>
					<span class="p-inputgroup-addon">
						<i class="fak fa-str-calendar"></i>
					</span>
				</div>
				<p-button
					[icon]="controller.dateSortCssIconClass$ | async"
					(onClick)="onDateSortClick()"
					styleClass="p-button-grey border-none"
				></p-button>
			</div>
		</div>
	</div>
	<div class="md:flex md:flex-1 grid grid-cols-3 gap-6">
		<div class="md:hidden self-center whitespace-pre-line">
			{{ controller.i18n + '.description.text' | translate }}
		</div>
		<div class="col-span-2 w-full">
			<span class="p-input-icon-right w-full">
				<i class="fak fa-str-filter"></i>
				<input
					[placeholder]="
						controller.i18n + '.descriptionInput.placeholder' | translate
					"
					class="w-full"
					formControlName="description"
					pInputText
					type="text"
				/>
			</span>
		</div>
	</div>
	<div class="md:flex md:flex-none md:w-28 grid grid-cols-3 gap-6">
		<div class="md:hidden self-center whitespace-pre-line">
			{{ controller.i18n + '.status.text' | translate }}
		</div>
		<div class="col-span-2">
			<p-multiSelect
				[options]="controller.taskStatusOptions$ | async"
				class="w-full"
				appendTo="body"
				formControlName="statuses"
				styleClass="w-full"
			></p-multiSelect>
		</div>
	</div>
	<div class="md:flex-none md:w-10">
		<div class="flex justify-end">
			<p-progressSpinner
				*ngIf="controller.isExporting$ | async; else exportButton"
				class="self-center"
				styleClass="w-6 h-6"
			></p-progressSpinner>
			<ng-template #exportButton>
				<p-button
					[pTooltip]="controller.i18n + '.exportAllButton.text' | translate"
					(onClick)="onAddMeetingsExportClick()"
					icon="far fa-file-export"
					iconPos="right"
				></p-button>
			</ng-template>
		</div>
	</div>
</ng-container>
